export default __webpack_public_path__ + "img/home.02bcaf71.svg";